module.exports = __webpack_public_path__ + "img/seal-cq.d68a8b32.png";